console.log('integ loaded');

// Select all image elements on the page
const images = document.querySelectorAll('img');

// Iterate through each image and remove the srcset attribute
images.forEach(image => {
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
});